import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Trash2 } from 'lucide-react';
import { toast } from 'sonner';
import { useCart } from '@/context/CartContext';
import { useLanguage } from '@/i18n/LanguageContext';

import { API } from '@/lib/apiBase';

export const CartItemRow = ({ item }) => {
  const { removeFromCart } = useCart();
  const { t } = useLanguage();

  return (
    <Card key={item.photo_id} className="bg-card border-border">
      <CardContent className="p-4">
        <div className="flex gap-4">
          <div className="w-20 h-20 rounded-sm overflow-hidden flex-shrink-0">
            <img
              src={`${API}/photos/${item.photo_id}/preview?size=thumb`}
              alt={t('common.photoAlt')}
              loading="lazy"
              decoding="async"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="flex-1 min-w-0">
            <div className="flex items-start justify-between gap-4">
              <div>
                <h3 className="font-semibold text-sm">
                  {item.is_class_photo ? t('gallery.classPhoto') : t('gallery.individualPhotos')}
                </h3>
                <p className="text-xs text-muted-foreground mt-0.5">
                  {t('prints.digitalDownload')}
                </p>
              </div>
              <Button
                variant="ghost" size="icon"
                onClick={() => { removeFromCart(item.photo_id); toast.info(t('cart.removeFromCart')); }}
                className="text-muted-foreground hover:text-destructive h-8 w-8"
                data-testid={`remove-${item.photo_id}`}
              >
                <Trash2 className="w-4 h-4" />
              </Button>
            </div>
            <div className="mt-1 font-mono text-base font-bold text-primary">
              CHF {item.price?.toFixed(2)}
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
